<template>
  <thead class="border-1 fs-small lh-md">
    <tr>
      <th scope="col" class="text-center bg-c02 text-white px-4 py-1">
        種別
      </th>
      <th scope="col" class="text-center bg-c02 text-white px-3 py-1">
        担当者
      </th>
      <th scope="col" class="text-center bg-c02 text-white px-4 px-lg-3 py-1">
        時間
      </th>
      <th scope="col" class="text-center bg-c02 text-white px-5 py-1">
        車種
      </th>
      <th scope="col" class="text-center bg-c02 text-white px-4 px-lg-3 py-1">
        協力店
      </th>
      <th scope="col" class="text-center bg-c02 text-white px-5 py-1">
        配送先
      </th>
      <th scope="col" class="text-center bg-c02 text-white px-4 px-lg-3 py-1">
        備考
      </th>
      <th
        scope="col"
        class="text-center bg-c02 text-white px-5 px-lg-4 py-1"
        v-if="!isMobile"
      >
        更新
      </th>
      <th scope="col" class="text-center bg-c02 text-white w-5em py-1">
        処理
      </th>
    </tr>
  </thead>
</template>

<script lang="ts">
/* Import Modules */
import { defineComponent } from "vue";
/* Import Compoments. */
/* Import Scripts. */
/* Import Variables */
export default defineComponent({
  props: {
    isMobile: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },
  },
  setup(props: { isMobile: Boolean }) {
    const isMobile = props.isMobile;
    return {
      /* valiables */
      isMobile,
      /* script */
    };
  },
});
</script>
